var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinneva(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 40,
    viewBox: "0 0 125 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0119 15.3616C45.2188 15.3616 45.3298 15.4569 45.3298 15.6479V16.9357C45.3298 17.1264 45.2185 17.222 45.0119 17.222H39.176C38.8815 17.2149 38.5874 17.247 38.3013 17.3173C38.0963 17.3653 37.909 17.4701 37.7608 17.6195C37.6073 17.7688 37.5067 17.9642 37.4746 18.176C37.4053 18.4677 37.3733 18.7669 37.3792 19.0666V19.3209H44.9485C44.9892 19.3168 45.0303 19.3218 45.0688 19.3356C45.1074 19.3493 45.1423 19.3715 45.1713 19.4004C45.2002 19.4293 45.2223 19.4643 45.2361 19.5028C45.2498 19.5413 45.2548 19.5824 45.2507 19.6231V20.6884C45.2548 20.7291 45.2498 20.7702 45.2361 20.8087C45.2223 20.8472 45.2002 20.8822 45.1713 20.9112C45.1423 20.9401 45.1074 20.9622 45.0688 20.976C45.0303 20.9897 44.9892 20.9947 44.9485 20.9906H37.3792V24.4888C37.3792 24.6797 37.2839 24.775 37.077 24.775H35.6302C35.4233 24.775 35.328 24.6797 35.328 24.4888V18.9086C35.3138 18.3553 35.3835 17.8031 35.5349 17.2708C35.6486 16.8527 35.874 16.4735 36.187 16.1738C36.515 15.8721 36.9144 15.6587 37.3476 15.5537C37.9201 15.4159 38.5079 15.3519 39.0966 15.3631L45.0119 15.3616ZM48.4147 15.3616C48.6213 15.3616 48.7169 15.4569 48.7169 15.6479V24.4885C48.7169 24.6794 48.6216 24.7747 48.4147 24.7747H46.9675C46.7609 24.7747 46.6496 24.6794 46.6496 24.4885V15.649C46.6496 15.4584 46.7609 15.3628 46.9675 15.3628L48.4147 15.3616ZM52.8988 15.3616C53.0792 15.3577 53.2597 15.3631 53.4396 15.3776C53.5724 15.4006 53.701 15.4435 53.8211 15.5049C53.9391 15.5597 54.0426 15.6414 54.1233 15.7435C54.2536 15.8647 54.3661 16.0038 54.4572 16.1567L59.4661 22.724C59.4843 22.7537 59.51 22.7781 59.5406 22.7949C59.5712 22.8116 59.6056 22.82 59.6405 22.8193H59.7677C59.8471 22.8193 59.879 22.7717 59.879 22.6763V15.649C59.8735 15.6101 59.8771 15.5705 59.8895 15.5333C59.9019 15.496 59.9229 15.4622 59.9506 15.4344C59.9784 15.4066 60.0123 15.3857 60.0495 15.3733C60.0868 15.3608 60.1264 15.3573 60.1653 15.3628H61.5804C61.787 15.3628 61.8826 15.4581 61.8826 15.649V23.3767C61.8826 23.9331 61.7873 24.299 61.5804 24.4896C61.4556 24.5946 61.3113 24.674 61.1558 24.7231C61.0003 24.7722 60.8366 24.7901 60.6741 24.7759H59.5135C59.3384 24.7795 59.1632 24.7742 58.9887 24.7599C58.8622 24.7398 58.7391 24.7023 58.6228 24.6486C58.5025 24.5903 58.3946 24.5094 58.3049 24.4103C58.1749 24.2789 58.0582 24.1352 57.9562 23.9811L52.9313 17.4138C52.9118 17.3853 52.8858 17.3619 52.8555 17.3453C52.8252 17.3288 52.7915 17.3196 52.757 17.3185H52.6297C52.566 17.3185 52.5342 17.3661 52.5344 17.4614V24.4896C52.5381 24.5296 52.5327 24.5698 52.5186 24.6073C52.5045 24.6449 52.4821 24.6787 52.4529 24.7063C52.4238 24.7339 52.3888 24.7545 52.3506 24.7665C52.3123 24.7786 52.2718 24.7818 52.2322 24.7759H50.817C50.6104 24.7759 50.5148 24.6805 50.5148 24.4896V16.762C50.5148 16.2055 50.6101 15.8396 50.801 15.649C51.0607 15.4394 51.3906 15.337 51.7233 15.3628L52.8988 15.3616ZM66.0651 15.3616C66.2455 15.3577 66.426 15.3631 66.6059 15.3776C66.7388 15.4006 66.8674 15.4435 66.9874 15.5049C67.1054 15.5598 67.2089 15.6415 67.2897 15.7435C67.4206 15.8681 67.5375 16.0066 67.6384 16.1567L72.6316 22.724C72.6498 22.7537 72.6755 22.7782 72.706 22.7949C72.7366 22.8116 72.7711 22.82 72.8059 22.8193H72.9332C73.0125 22.8193 73.0445 22.7717 73.0445 22.6763V15.649C73.0445 15.4584 73.1398 15.3628 73.3467 15.3628H74.7459C74.9528 15.3628 75.0481 15.4581 75.0481 15.649V23.3767C75.0481 23.9331 74.9528 24.299 74.7459 24.4896C74.6211 24.5946 74.4768 24.674 74.3213 24.7231C74.1657 24.7722 74.002 24.7901 73.8395 24.7759H72.6789C72.5038 24.7795 72.3287 24.7742 72.1541 24.7599C72.0276 24.7398 71.9045 24.7023 71.7883 24.6486C71.668 24.5903 71.5601 24.5094 71.4704 24.4103C71.3404 24.279 71.2236 24.1352 71.1217 23.9811L66.0968 17.4138C66.0772 17.3853 66.0513 17.3619 66.021 17.3453C65.9907 17.3288 65.9569 17.3196 65.9224 17.3185H65.7951C65.7314 17.3185 65.6996 17.3661 65.6998 17.4614V24.4896C65.7036 24.5296 65.6982 24.5698 65.6841 24.6073C65.67 24.6449 65.6475 24.6787 65.6184 24.7063C65.5893 24.7339 65.5543 24.7545 65.516 24.7665C65.4778 24.7786 65.4373 24.7818 65.3976 24.7759H63.9825C63.7758 24.7759 63.6802 24.6805 63.6802 24.4896V16.762C63.6802 16.2055 63.7755 15.8396 63.9665 15.649C64.2261 15.4394 64.5561 15.337 64.8888 15.3628L66.0651 15.3616ZM86.4189 15.3616C86.6258 15.3616 86.7368 15.4569 86.7368 15.6479V16.9357C86.7368 17.1264 86.6255 17.222 86.4189 17.222H80.5356C80.2464 17.2148 79.9575 17.2469 79.6769 17.3173C79.4673 17.3653 79.2748 17.4698 79.1204 17.6195C78.9669 17.7688 78.8664 17.9642 78.8342 18.176C78.7788 18.4696 78.7522 18.7679 78.7546 19.0666V19.1939H86.3555C86.3968 19.1868 86.4392 19.1897 86.4791 19.2024C86.5191 19.215 86.5553 19.2371 86.585 19.2667C86.6146 19.2963 86.6367 19.3326 86.6493 19.3726C86.662 19.4125 86.6649 19.4549 86.6578 19.4961V20.5632C86.6578 20.7538 86.5624 20.8494 86.3555 20.8494H78.7546V21.088C78.7521 21.3815 78.7788 21.6745 78.8342 21.9627C78.8701 22.1779 78.9698 22.3773 79.1204 22.5351C79.2762 22.6797 79.4687 22.7787 79.6769 22.8214C79.9575 22.8918 80.2464 22.9238 80.5356 22.9167H86.4192C86.6261 22.9167 86.7371 23.012 86.7371 23.2029V24.4908C86.7371 24.6817 86.6258 24.777 86.4192 24.777H80.5036C79.9211 24.785 79.3396 24.7265 78.7703 24.6027C78.3368 24.5128 77.9365 24.3049 77.6138 24.0018C77.2911 23.6987 77.0584 23.3123 76.9416 22.8853C76.7904 22.3475 76.7208 21.79 76.735 21.2315V18.91C76.7207 18.3568 76.7903 17.8046 76.9416 17.2723C77.0585 16.8453 77.2912 16.4589 77.6139 16.1558C77.9366 15.8527 78.3368 15.6448 78.7703 15.5549C79.3374 15.417 79.9201 15.3529 80.5036 15.3642L86.4189 15.3616ZM89.5038 15.3616C89.574 15.3605 89.6438 15.3712 89.7104 15.3933C89.755 15.4346 89.7926 15.4829 89.8217 15.5363L93.7656 22.7717C93.7789 22.8021 93.8013 22.8277 93.8298 22.8448C93.8583 22.8619 93.8914 22.8696 93.9245 22.867H93.9882C94.0206 22.8657 94.0521 22.8563 94.08 22.8396C94.1078 22.823 94.131 22.7996 94.1474 22.7717L98.0274 15.536C98.0551 15.477 98.1008 15.4283 98.1579 15.397C98.215 15.3657 98.2807 15.3533 98.3453 15.3616H100.11C100.206 15.3616 100.285 15.3933 100.301 15.441C100.311 15.4783 100.313 15.5172 100.308 15.5555C100.302 15.5937 100.289 15.6305 100.269 15.6635L95.8485 23.7597C95.6963 24.0809 95.4734 24.3635 95.1965 24.5864C94.9634 24.7162 94.7001 24.782 94.4334 24.777H93.654C93.3561 24.7892 93.0601 24.7235 92.7953 24.5864C92.4988 24.3755 92.263 24.0904 92.1115 23.7597L87.6431 15.6662C87.6195 15.6348 87.6041 15.5979 87.5986 15.559C87.5931 15.52 87.5975 15.4803 87.6115 15.4436C87.6274 15.3959 87.6908 15.3642 87.8181 15.3642L89.5038 15.3616ZM104.833 15.3616C105.132 15.3505 105.429 15.422 105.691 15.5682C105.984 15.7765 106.219 16.0555 106.375 16.3793L110.828 24.4728C110.871 24.5384 110.888 24.6178 110.875 24.6954C110.843 24.759 110.78 24.7747 110.668 24.7747H108.967C108.902 24.7831 108.837 24.7707 108.779 24.7394C108.722 24.708 108.676 24.6594 108.649 24.6004L107.695 22.8673H101.366L100.445 24.6024C100.415 24.6601 100.369 24.7076 100.313 24.7387C100.256 24.7699 100.191 24.7831 100.127 24.7767H98.3775C98.2662 24.7767 98.2032 24.7608 98.1709 24.6974C98.1516 24.6219 98.163 24.5419 98.2026 24.4748L102.623 16.3813C102.779 16.0622 103.008 15.7844 103.291 15.5703C103.513 15.4263 103.774 15.3541 104.039 15.3637L104.833 15.3616ZM102.225 21.3082H106.852L104.706 17.3649C104.694 17.3366 104.674 17.3123 104.649 17.2953C104.623 17.2783 104.593 17.2694 104.563 17.2696H104.484C104.453 17.2694 104.423 17.2783 104.398 17.2953C104.372 17.3123 104.353 17.3366 104.341 17.3649L102.225 21.3082Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_841_2116",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 11,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7122 22.8459C22.7122 23.1833 22.5782 23.5069 22.3396 23.7455C22.101 23.9841 21.7775 24.1181 21.44 24.1181C21.1026 24.1181 20.7791 23.9841 20.5405 23.7455C20.3019 23.5069 20.1678 23.1833 20.1678 22.8459V17.869C20.1687 17.7029 20.2023 17.5387 20.2667 17.3856C20.3311 17.2326 20.4251 17.0938 20.5432 16.9771C20.6614 16.8604 20.8014 16.7682 20.9552 16.7057C21.1091 16.6433 21.2737 16.6118 21.4398 16.613H26.5759C26.7424 16.6104 26.9076 16.641 27.0621 16.703C27.2166 16.7649 27.3571 16.8571 27.4756 16.974C27.594 17.091 27.688 17.2303 27.752 17.384C27.8159 17.5376 27.8486 17.7025 27.8481 17.869C27.849 18.0363 27.8167 18.2021 27.7531 18.3569C27.6895 18.5116 27.5958 18.6522 27.4775 18.7705C27.3592 18.8888 27.2186 18.9825 27.0638 19.0461C26.9091 19.1097 26.7432 19.142 26.5759 19.1412H22.7111L22.7122 22.8459ZM15 27.7278C15.001 28.0649 15.1354 28.3879 15.3737 28.6263C15.6121 28.8646 15.9351 28.999 16.2722 29C16.4383 28.9992 16.6026 28.9656 16.7557 28.9012C16.9088 28.8368 17.0476 28.7428 17.1643 28.6246C17.281 28.5064 17.3733 28.3664 17.4358 28.2125C17.4982 28.0586 17.5297 27.8939 17.5284 27.7278V13.5281H31.7284C31.8944 13.5294 32.0591 13.498 32.213 13.4355C32.3669 13.373 32.5069 13.2808 32.6251 13.1642C32.7433 13.0475 32.8373 12.9087 32.9017 12.7556C32.9662 12.6025 32.9998 12.4383 33.0006 12.2722C32.9997 11.9351 32.8653 11.612 32.6269 11.3736C32.3886 11.1352 32.0655 11.0009 31.7284 11H16.2722C15.9351 11.001 15.6121 11.1354 15.3737 11.3737C15.1354 11.6121 15.001 11.9351 15 12.2722V27.7278Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_841_2116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7987 13.6555L34.7511 13.6871L25.2578 2.65228L25.3055 2.62061",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.798 13.6555L34.6707 13.7668L25.1777 2.7319L25.305 2.62061",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7032 13.7362L34.5759 13.8475L25.082 2.81003L25.2093 2.69873",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6223 13.8144L34.4793 13.9257L24.9863 2.89084L25.1293 2.77954",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5285 13.878L34.4012 14.0053L24.9082 2.97043L25.0355 2.85913",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4328 13.9575L34.3055 14.0847L24.8125 3.04988L24.9398 2.92261",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3527 14.0371L34.2098 14.1484L24.7168 3.1135L24.8598 3.0022",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.257 14.1164L34.1297 14.2277L24.6367 3.19284L24.764 3.08154",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1792 14.196L34.0359 14.3073L24.543 3.27244L24.6859 3.16113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 14.2753L33.9562 14.3866L24.4629 3.35177L24.5902 3.24048",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9875 14.3389L33.8602 14.4662L24.3672 3.43136L24.4945 3.32007",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9075 14.4186L33.7645 14.5459L24.2715 3.51106L24.4145 3.38379",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8117 14.498L33.6844 14.6093L24.1914 3.59017L24.3187 3.46289",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7179 14.5778L33.5906 14.6891L24.0977 3.65426L24.2406 3.54297",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6382 14.6572L33.4949 14.7685L24.002 3.73361L24.1449 3.62231",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5421 14.7368L33.4149 14.8481L23.9219 3.8132L24.0491 3.7019",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4624 14.8161L33.3195 14.9274L23.8262 3.89254L23.9691 3.78125",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3664 14.8801L33.2391 15.0074L23.7461 3.9725L23.8734 3.84521",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2726 14.9595L33.1453 15.0708L23.6523 4.05159L23.7796 3.92432",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1926 15.039L33.0496 15.1503L23.5566 4.11544L23.6996 4.00415",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0968 15.1184L32.9695 15.2296L23.4766 4.19479L23.6038 4.0835",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0011 15.198L32.8738 15.3093L23.3809 4.27415L23.5238 4.16284",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9211 15.2773L32.7782 15.3886L23.2852 4.35373L23.4281 4.24243",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8273 15.341L32.7 15.4683L23.207 4.43343L23.3343 4.30615",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7473 15.4202L32.6043 15.5315L23.1113 4.51228L23.2543 4.38501",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6515 15.4997L32.5242 15.611L23.0312 4.57614L23.1585 4.46484",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5558 15.5803L32.4285 15.6916L22.9355 4.6567L23.0628 4.54541",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4767 15.6587L32.3337 15.77L22.8398 4.73629L22.9831 4.625",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.382 15.7385L32.2547 15.8498L22.7617 4.81492L22.889 4.70361",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.302 15.8019L32.159 15.9292L22.666 4.89436L22.809 4.76709",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2063 15.8818L32.0633 15.9931L22.5703 4.97273L22.7133 4.84546",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1105 15.9611L31.9832 16.0724L22.4902 5.03756L22.6175 4.92627",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0308 16.0405L31.8875 16.1518L22.3945 5.11667L22.5375 5.00537",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9367 16.1201L31.8094 16.2314L22.3164 5.1965L22.4437 5.08521",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.841 16.1986L31.7137 16.3099L22.2207 5.2756L22.348 5.16431",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7613 16.2632L31.6183 16.3904L22.125 5.35471L22.268 5.24341",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6652 16.3425L31.5379 16.4538L22.0449 5.43466L22.1722 5.30737",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5871 16.4218L31.4442 16.5331L21.9512 5.49827L22.0944 5.38696",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4914 16.5017L31.3484 16.6129L21.8711 5.57809L21.9984 5.4668",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3957 16.5812L31.2684 16.6925L21.7754 5.65769L21.9027 5.54639",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3156 16.6608L31.1727 16.7721L21.6797 5.73727L21.8227 5.62598",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2218 16.7244L31.0946 16.8517L21.6016 5.81686L21.7288 5.70557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1242 16.8037L30.9969 16.9309L21.5039 5.89607L21.6312 5.7688",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0464 16.8833L30.9034 16.9946L21.4102 5.95944L21.5531 5.84814",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9503 16.9626L30.8231 17.0739L21.3301 6.03903L21.4574 5.92773",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8703 17.0422L30.7274 17.1535L21.2344 6.11862L21.3773 6.00732",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7745 17.1215L30.6316 17.2328L21.1543 6.19796L21.2816 6.08667",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6808 17.1852L30.5535 17.3125L21.0605 6.27731L21.1878 6.16602",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6008 17.2649L30.4578 17.3922L20.9648 6.35702L21.1078 6.22974",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.505 17.3444L30.3778 17.4557L20.8848 6.42086L21.012 6.30957",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4093 17.4246L30.282 17.5359L20.7891 6.50021L20.9163 6.38892",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3296 17.5035L30.1866 17.6148L20.6934 6.58078L20.8363 6.46948",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2335 17.5827L30.1063 17.694L20.6133 6.65915L20.7406 6.54785",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1555 17.6466L30.0125 17.7738L20.5195 6.73898L20.6625 6.62769",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.06 17.7258L29.9327 17.853L20.4395 6.81673L20.5667 6.68945",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.964 17.8054L29.8367 17.9167L20.3438 6.8818L20.471 6.77051",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.884 17.885L29.741 17.9962L20.248 6.96139L20.391 6.8501",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7902 17.9643L29.6629 18.0756L20.1699 7.04074L20.2972 6.92944",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6945 18.0427L29.5672 18.154L20.0742 7.11911L20.2172 7.00781",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6147 18.1076L29.4718 18.2349L19.9785 7.19919L20.1215 7.08789",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5187 18.1872L29.3914 18.3145L19.8984 7.27937L20.0257 7.1521",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4387 18.2666L29.2957 18.3779L19.8027 7.35872L19.9457 7.23145",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3449 18.3461L29.2176 18.4574L19.7246 7.42257L19.8519 7.31128",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2492 18.4255L29.1219 18.5368L19.6289 7.50192L19.7562 7.39062",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1692 18.5051L29.0262 18.6164L19.5332 7.58151L19.6762 7.47021",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0734 18.5844L28.9461 18.6957L19.4531 7.66086L19.5804 7.54956",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9777 18.6484L28.8504 18.7757L19.3574 7.7408L19.5004 7.61353",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8996 18.7278L28.7566 18.8391L19.2637 7.81991L19.4066 7.69263",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8038 18.8074L28.6766 18.9187L19.1836 7.88351L19.3109 7.77222",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7238 18.8867L28.5809 18.998L19.0879 7.96287L19.2309 7.85156",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6281 18.9663L28.5008 19.0775L19.0078 8.04269L19.1351 7.9314",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5343 19.0458L28.407 19.1571L18.9141 8.12228L19.0413 8.01099",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4527 19.1094L28.3097 19.2366L18.8164 8.20149L18.9594 8.07422",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3585 19.1889L28.2313 19.3002L18.7383 8.28108L18.8656 8.15381",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2788 19.2687L28.1356 19.38L18.6426 8.34518L18.7855 8.23389",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1831 19.3477L28.0402 19.459L18.5469 8.42477L18.6901 8.31348",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0874 19.4272L27.9601 19.5385L18.4668 8.50338L18.5941 8.39209",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.009 19.5068L27.866 19.6181L18.373 8.58322L18.516 8.47192",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9132 19.5705L27.7859 19.6978L18.293 8.66292L18.4202 8.53564",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8175 19.65L27.6902 19.7612L18.1973 8.74324L18.3245 8.61597",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7378 19.7294L27.5945 19.8407L18.1016 8.80587L18.2448 8.69458",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6437 19.809L27.5164 19.9203L18.0234 8.88546L18.1507 8.77417",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5637 19.8872L27.4207 19.9984L17.9277 8.96359L18.0707 8.85229",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4679 19.9679L27.3249 20.0792L17.8477 9.04318L17.9749 8.93188",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3722 20.0316L27.2449 20.1588L17.752 9.12399L17.8792 9.0127",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2942 20.1113L27.1512 20.2386L17.6582 9.20369L17.8015 9.07642",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1984 20.1906L27.0711 20.3019L17.5781 9.26706L17.7054 9.15576",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1027 20.2702L26.9754 20.3815L17.4824 9.34665L17.6097 9.23535",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.023 20.3498L26.8797 20.4611L17.3867 9.42624L17.5297 9.31494",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9269 20.429L26.7996 20.5395L17.3066 9.50461L17.4339 9.39331",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8472 20.4928L26.7039 20.62L17.2109 9.58517L17.3542 9.47388",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7531 20.572L26.6101 20.6992L17.1328 9.66438L17.2601 9.53711",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6574 20.6518L26.5301 20.7631L17.0371 9.72825L17.1644 9.61694",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5774 20.7309L26.4344 20.8422L16.9414 9.8071L17.0844 9.6958",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4816 20.8107L26.3543 20.922L16.8613 9.88718L16.9886 9.77588",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3859 20.8899L26.2586 21.0012L16.7656 9.96603L16.8929 9.85474",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3059 20.9537L26.1629 21.081L16.6699 10.0461L16.8129 9.93481",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.212 21.0331L26.0848 21.1604L16.5918 10.1256L16.7191 9.99829",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.132 21.1132L25.9891 21.2245L16.4961 10.1897L16.6393 10.0784",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0363 21.1922L25.909 21.3035L16.416 10.2693L16.5433 10.158",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9406 21.2717L25.8133 21.383L16.3203 10.3479L16.4476 10.2366",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8609 21.3513L25.7179 21.4626L16.2246 10.4275L16.3676 10.3162",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7667 21.4149L25.6395 21.5421L16.1465 10.5073L16.2738 10.396",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6713 21.4945L25.5441 21.6217L16.0508 10.5875L16.1781 10.4602",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5913 21.5737L25.4481 21.685L15.9551 10.6659L16.098 10.5386",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4958 21.6536L25.3686 21.7649L15.875 10.7297L16.0023 10.6184",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4172 21.7331L25.2742 21.8444L15.7812 10.8095L15.9242 10.6982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3203 21.8138L25.1931 21.9251L15.6992 10.8877L15.8265 10.7764",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2257 21.892L25.0985 22.0033L15.6055 10.9685L15.7328 10.8572",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1457 21.9555L25.0027 22.0828L15.5098 11.0479L15.6527 10.9207",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.05 22.0349L24.9227 22.1462L15.4297 11.127L15.557 10.9998",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9562 22.1145L24.8289 22.2257L15.3359 11.1909L15.4789 11.0796",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8765 22.1938L24.7332 22.3051L15.2402 11.27L15.3835 11.1587",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7804 22.2734L24.6531 22.3847L15.1602 11.3498L15.2874 11.2385",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7007 22.3527L24.5577 22.464L15.0645 11.4292L15.2074 11.3179",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6046 22.4167L24.4774 22.544L14.9844 11.5091L15.1117 11.3818",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5109 22.4961L24.3836 22.6074L14.8906 11.5882L15.0179 11.4609",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4312 22.5756L24.2882 22.6869L14.7949 11.6521L14.9379 11.5408",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3351 22.6552L24.2078 22.7665L14.7148 11.7317L14.8421 11.6204",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2394 22.7346L24.1121 22.8459L14.6191 11.8108L14.7621 11.6995",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1594 22.8144L24.0164 22.9257L14.5234 11.8908L14.6664 11.7795",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0656 22.8776L23.9383 23.0049L14.4453 11.9701L14.5726 11.8428",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9859 22.9573L23.8426 23.0686L14.3496 12.0494L14.4929 11.9221",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8898 23.0365L23.7625 23.1478L14.2695 12.1132L14.3968 12.002",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7941 23.1162L23.6668 23.2275L14.1738 12.1924L14.3011 12.0811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7141 23.1955L23.5711 23.3068L14.0781 12.2719L14.2211 12.1606",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6203 23.2754L23.493 23.3867L14 12.3515L14.1273 12.2402",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5405 23.3387L23.3973 23.466L13.9043 12.4317L14.0473 12.3044",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4445 23.4184L23.3015 23.5297L13.8242 12.5106L13.9515 12.3833",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3488 23.4977L23.2215 23.609L13.7285 12.5742L13.8558 12.4629",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2707 23.5773L23.1278 23.6886L13.6348 12.6538L13.7777 12.5425",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.175 23.6579L23.0477 23.7692L13.5547 12.7341L13.682 12.6228",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0793 23.7363L22.952 23.8476L13.459 12.8139L13.5863 12.7026",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9992 23.7999L22.8563 23.9272L13.3633 12.8923L13.5063 12.781",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9035 23.8796L22.7762 24.0069L13.2832 12.972L13.4105 12.8447",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8235 23.9592L22.6805 24.0705L13.1875 13.0354L13.3305 12.9241",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7296 24.0385L22.5864 24.1498L13.1094 13.115L13.2366 13.0037",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6339 24.1181L22.5067 24.2295L13.0137 13.1943L13.141 13.083",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5542 24.1975L22.411 24.3103L12.918 13.2751L13.0609 13.1638",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4581 24.2611L22.3309 24.3883L12.8379 13.3535L12.9652 13.2422",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3644 24.3405L22.2371 24.4678L12.7441 13.4329L12.8714 13.3057",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2844 24.4202L22.1414 24.5315L12.6484 13.4963L12.7914 13.385",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1886 24.4995L22.0614 24.6108L12.5684 13.5759L12.6957 13.4646",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1086 24.5791L21.9656 24.6904L12.4727 13.6552L12.6156 13.5439",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0128 24.6584L21.8856 24.7697L12.3926 13.7348L12.5199 13.6235",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9171 24.722L21.7899 24.8493L12.2969 13.8142L12.4242 13.7029",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8391 24.8017L21.6961 24.929L12.2031 13.8941L12.3461 13.7668",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7433 24.8813L21.616 24.9926L12.123 13.9577L12.2503 13.8464",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6476 24.9609L21.5203 25.0722L12.0273 14.0371L12.1546 13.9258",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5676 25.0402L21.4246 25.1515L11.9316 14.1167L12.0746 14.0054",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4738 25.1198L21.3465 25.2311L11.8535 14.1963L11.9808 14.085",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3941 25.1838L21.2511 25.311L11.7578 14.2756L11.9008 14.1643",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.298 25.2631L21.1707 25.3904L11.6777 14.3555L11.805 14.2283",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2023 25.3425L21.075 25.4538L11.582 14.4347L11.7093 14.3074",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1232 25.4221L20.9802 25.5334L11.4863 14.4983L11.6293 14.387",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0285 25.5021L20.9012 25.6134L11.4082 14.5786L11.5355 14.4673",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9317 25.5809L20.8044 25.6922L11.3105 14.6582L11.4538 14.5469",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8528 25.6604L20.7098 25.7716L11.2168 14.7368L11.3598 14.6255",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7579 25.7239L20.6306 25.8511L11.1367 14.816L11.264 14.6887",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6773 25.8034L20.5343 25.9147L11.041 14.8944L11.184 14.7671",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5824 25.8828L20.4551 25.9941L10.9609 14.9592L11.0882 14.8479",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4857 25.9626L20.3584 26.0739L10.8672 15.0388L10.9945 14.9275",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4075 26.0417L20.2645 26.153L10.7715 15.1179L10.9145 15.0066",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3119 26.1204L20.1846 26.2317L10.6934 15.1977L10.8206 15.0864",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.216 26.185L20.0887 26.3123L10.5957 15.2774L10.7387 15.1501",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1379 26.2649L19.9949 26.3762L10.502 15.357L10.6449 15.2297",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0421 26.3442L19.9149 26.4555L10.4219 15.4206L10.5491 15.3093",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9621 26.4238L19.8192 26.5351L10.3262 15.5002L10.4691 15.3889",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8664 26.5029L19.7391 26.6142L10.2461 15.5793L10.3734 15.468",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7707 26.5827L19.6434 26.694L10.1504 15.6589L10.2777 15.5476",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6929 26.6457L19.5496 26.773L10.0566 15.7381L10.1999 15.6108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5968 26.7256L19.4696 26.8369L9.97656 15.8177L10.1038 15.6904",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5168 26.8051L19.3739 26.9164L9.88086 15.8816L10.0238 15.7703",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4211 26.885L19.2782 26.9962L9.78516 15.9614L9.92813 15.8501",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3253 26.9643L19.1981 27.0756L9.70508 16.0407L9.83235 15.9294",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2476 27.0439L19.1043 27.1552L9.61133 16.1203L9.7543 16.009",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1515 27.1075L19.0242 27.2348L9.53125 16.1999L9.65854 16.0886",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0558 27.1868L18.9285 27.314L9.43555 16.2789L9.56282 16.1516",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9758 27.2666L18.8328 27.3778L9.33984 16.343L9.48282 16.2317",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.882 27.3464L18.7547 27.4577L9.26172 16.4228L9.38901 16.3115",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8023 27.4254L18.6593 27.5367L9.16602 16.5024L9.30927 16.3911",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7062 27.5046L18.5632 27.6159L9.08594 16.581L9.21321 16.4697",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6105 27.5683L18.4832 27.6955L8.99023 16.6607L9.11868 16.5505",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5305 27.6479L18.3875 27.7752L8.89453 16.7403L9.0375 16.613",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4367 27.7275L18.3094 27.8388L8.81641 16.8039L8.94368 16.6926",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.341 27.8068L18.2137 27.9181L8.7207 16.8833L8.84799 16.772",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.261 27.8864L18.118 27.9977L8.625 16.9629L8.76797 16.8516",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1652 27.9646L18.0379 28.0759L8.54492 17.0422L8.6722 16.9309",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0866 28.0296L17.9436 28.1568L8.45117 17.1208L8.59444 17.0095",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9914 28.1088L17.8484 28.2361L8.37109 17.2013L8.49838 17.074",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8957 28.1885L17.7684 28.2998L8.27539 17.2646L8.40267 17.1533",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8156 28.268L17.6727 28.3793L8.17969 17.3444L8.32266 17.2332",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7199 28.3474L17.5926 28.4587L8.09961 17.4238L8.22689 17.3125",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6242 28.4272L17.4969 28.5385L8.00391 17.5034L8.13118 17.3921",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5464 28.4906L17.4034 28.6179L7.91016 17.5827L8.05342 17.4714",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4503 28.5703L17.3231 28.6975L7.83008 17.6627L7.95735 17.5354",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3703 28.6496L17.2274 28.7609L7.73438 17.726L7.87764 17.6147",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2746 28.7292L17.1473 28.8405L7.6543 17.8054L7.78158 17.6941",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1789 28.8085L17.0516 28.9198L7.55859 17.885L7.68587 17.7737",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1008 28.8881L16.9578 28.9994L7.46484 17.9646L7.60782 17.8533",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.005 28.9517L16.8778 29.079L7.38477 18.0442L7.51205 17.9329",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9093 29.0314L16.782 29.1587L7.28906 18.1239L7.41634 17.9966",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8293 29.1108L16.6864 29.2221L7.19336 18.203L7.33633 18.0757",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7355 29.1907L16.6082 29.302L7.11523 18.2666L7.24252 18.1553",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6538 29.2699L16.5109 29.3812L7.01758 18.3469L7.16083 18.2356",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.56 29.3493L16.4327 29.4606L6.93945 18.4257L7.06673 18.3145",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.464 29.4287L16.3367 29.54L6.84375 18.5051L6.97102 18.3938",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3852 29.4924L16.2419 29.6197L6.74805 18.5846L6.89102 18.4573",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2882 29.5716L16.161 29.6829L6.66797 18.6649L6.79525 18.5376",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1937 29.6514L16.1141 29.731L6.62109 18.6958L6.71641 18.6162",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinneva);
export default __webpack_public_path__ + "static/media/finneva.d6d3cf77367d096477226184e40c53aa.svg";
export { ForwardRef as ReactComponent };